import { PAYMENT_OPEN } from "../../../common/flags";
import React from "react";
import classNames from "../manage.module.css";
import { Button, LinearProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import Typography from "../../../components/ui/typography";

// Çift kayıt uyarısı. Backend'in mesajında diğer hesabın ID'si de var; öğrenciye ID'yi göstermemek için
// "diğer hesap ödenmiş" durumunda metni burada sadece (maskeli) e-postalarla kuruyoruz.
const paymentBlockText = (paymentBlock) =>
  paymentBlock.reason === "paid_duplicate" && paymentBlock.paid_accounts
    ? "Bu öğrenci adına ödemesi yapılmış başka bir hesap bulunmaktadır (" +
      paymentBlock.paid_accounts.map((a) => a.email).join(", ") +
      "). Çift kayıt olabileceği için bu hesapta ödeme kapatılmıştır, lütfen ödemesi yapılmış hesapla devam ediniz. Bir yanlışlık olduğunu düşünüyorsanız info@tzv.org.tr adresine e-posta gönderebilirsiniz."
    : paymentBlock.message;

// Çift kayıt nedeniyle ödemesi kapalı hesaplarda (backend: DuplicateUserManager.payment_blocks) buton yerine uyarı gösterilir.
export const PaymentBlockWarning = ({ paymentBlock }) => (
  <div
    style={{
      marginTop: 10,
      padding: "12px 16px",
      borderRadius: 8,
      background: "#fff3e0",
      borderLeft: "6px solid #e65100",
      color: "#333",
      fontSize: 16,
      lineHeight: 1.6,
    }}
  >
    <strong>⚠ Olası çift kayıt</strong>
    <div>{paymentBlockText(paymentBlock)}</div>
  </div>
);

export const PaymentInstructionsBox = ({ user, previewMode }) => {
  return (
    <div
      style={{ color: "white", fontSize: "1.3rem" }}
      className={"card " + classNames.left_step}
    >
      {/* <div>Kayıt/Ödeme süreci sona ermiştir. </div>  */}
      {!user.class_id && (
        <div>
          <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              fontSize: "18px",
            }}
          >
            {
              "Yarışmaya katılabilmek için lütfen ödeme yapınız. (Ödeme yapabilmek için önce sınıf ve okul bilgilerinizi güncelleyiniz.)"
            }
          </Typography>
        </div>
      )}
      {user.class_id && (
        <div>
          <Typography
            style={{
              fontStyle: "semibold",
              fontWeight: "bold",
              color: "orange",
              textDecoration: "underline",
              fontSize: "22px",
              marginBottom: "10px",
            }}
          >
            Açıklama
          </Typography>
          {user.payment_block && (
            <PaymentBlockWarning paymentBlock={user.payment_block} />
          )}
          <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              fontSize: "18px",
              marginBottom: "10px",
            }}
          >
            {user.payment_block
              ? null
              : PAYMENT_OPEN
              ? "Ödemeler 19 Ekim 2026 Pazartesi günü saat 13.00 itibarıyla başlamıştır. Yarışmaya katılım için gerekli ödeme işlemini aşağıdaki Ödeme Yap butonu ile gerçekleştirebilirsiniz."
              : "Ödemeler, 19 Ekim 2026 Pazartesi günü saat 13.00'te başlayacak olup, yarışmaya katılım için gerekli ödeme işlemlerini bu tarihten itibaren gerçekleştirebilirsiniz. 19 Ekim 2026 Pazartesi günü saat 13.00'ten itibaren Ödeme Yap butonu aktif olacaktır."}
          </Typography>
          <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              fontSize: "18px",
              marginBottom: "10px",
            }}
          >
            Ücretsiz Deneme Sınavı, 19 Şubat 2027 Cuma günü saat 13.00'te profil sayfanıza eklenecek ve 26 Şubat 2027 Cuma günü saat 17.00'ye kadar açık kalacaktır. Sınav ekranlarının tanıtımı amacıyla yapılacak olup sonuç açıklanmayacaktır.
          </Typography>
          {/*<div>Yarışmaya katılabilmek için lütfen ödeme yapınız.</div>*/}
        </div>
      )}
      {/* Sınıf seçilmemişse Açıklama bölümü yok; uyarı yine de görünsün. */}
      {user.payment_block && !user.class_id && (
        <PaymentBlockWarning paymentBlock={user.payment_block} />
      )}
      {PAYMENT_OPEN && user.class_id && !previewMode && !user.payment_block && (
        <Link to="/satinal">
          <Button
            style={{
              textDecoration: "none",
              backgroundColor: "green",
              fontSize: "20px",
              width: 140,
              height: 50,
              padding: 5,
              textAlign: "center",
              borderRadius: 6,
              marginTop: 6,
              color: "white",
              textTransform: "none",
            }}
          >
            Ödeme Yap
            <LinearProgress color="secondary" />
          </Button>
        </Link>
      )}
      {user.class_id && previewMode && (
        <Button
          disabled
          style={{
            fontSize: "20px",
            width: 140,
            height: 50,
            padding: 5,
            textAlign: "center",
            borderRadius: 6,
            marginTop: 6,
            textTransform: "none",
          }}
          title="Önizleme modunda ödeme işlemi başlatılamaz."
        >
          Ödeme Yap
        </Button>
      )}
    </div>
  );
};
